import { render, staticRenderFns } from "./ns-login.vue?vue&type=template&id=633b2522&"
import script from "./ns-login.vue?vue&type=script&lang=js&"
export * from "./ns-login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports